import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, fromEvent } from 'rxjs';
import { Subscription } from "rxjs";
import { UserInfoService } from "../services/user-info.service";
import { CommonService } from "../services/common.service";
import { AemService } from './aem.service'
import { UtilService } from './util.service'

@Injectable()
export class ArService {
    public arSubscriptionList = {
        isLoaded: false,
        isCheckboxFirstTimeChecked: false,
        showHeaderTooltip: false
    };
    private isArEnable: boolean = false;
    public arSavedTime: number;
    private subscription: Subscription = new Subscription();

    public currentEnv = ''
    private snsApiBasepath = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arauthorize.basepath'] : '';
    private snsApiSubKey = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.subkey'] : '';
    private snsApi = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.all.endpoint'] : '';
    private snsApiSubKeyHeader = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.subkeyHeader'] : '';
    private snsApiContentTypeHeader = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.contentTypeHeader'] : '';

    public httpOptions = {
        headers: new HttpHeaders({}),
    };

    constructor(
        private _http: HttpClient,
        private _userInfoService: UserInfoService,
        private _commonService: CommonService,
        private _aemService: AemService,
        private _utilService: UtilService
    ) {
        this.currentEnv = this._commonService.getCurrentEnviorment();

        if(this._aemService.isArFlagLoaded()){
            this.isArEnable = this._aemService.getArFlag()?.display;
            if(this.isArEnable) {
                this.getSubscriptionsInfo();
            } else {
                this._commonService.arSubscriptions.next({});
            }
        } else {
            this.subscription.add(
                fromEvent(document, 'arFlagLoaded').subscribe(event => {
                    const objArFlag = event && event['detail'] && event['detail']['arFlag'];
                    if(objArFlag) {
                        this.isArEnable = objArFlag['display'];
                    }
                    if(this.isArEnable) {
                        this.getSubscriptionsInfo();
                    } else {
                        this._commonService.arSubscriptions.next({});
                    }
                })
            );
        }
    }

    public getArSubscriptions(){
        return this.arSubscriptionList;
    }

    public getKeyValuePairSubs(subscriptions){
        const productSubsMap = {}
        for (const i in subscriptions) {
            productSubsMap[subscriptions[i].productId ? subscriptions[i].productId : subscriptions[i].productBpn] = subscriptions[i];
        }
        return productSubsMap;
    }

    public setArSubscription(data) {
        if(data != null && typeof data == 'object') {
            this.arSubscriptionList['arSavedTime'] = this.getArSavedTime();
            this.arSubscriptionList['isLoaded'] = true;
            this.arSubscriptionList['isCheckboxFirstTimeChecked'] = false;
            // subscribe to the last value of the boolean to show the header tooltip
            this._commonService.showHeaderTooltip.subscribe((value) => {
                if (value == true) {
                    this.arSubscriptionList['showHeaderTooltip'] = true;
                } else {
                    this.arSubscriptionList['showHeaderTooltip'] = false;
                }
            });
            this.arSubscriptionList['customerId'] = data.customerId ? data.customerId : data.customerUUID;
            this.arSubscriptionList['fulfillmentType'] = data.fulfillmentType;
            this.arSubscriptionList['subscribedItems'] = this.getKeyValuePairSubs(data.subscribedItems ? data.subscribedItems : data.itemsSubscribed);
            if(data.hasOwnProperty('snsFrequencies')) {
                this.arSubscriptionList['snsFrequencies'] = data.snsFrequencies;
            }
            if(data.hasOwnProperty('isNewSnSUser')) {
                this.arSubscriptionList['isNewSnSUser'] = data.isNewSnSUser;
            }
            if(data.hasOwnProperty('fulfillment')) {
                this.arSubscriptionList['fulfillment'] = data.fulfillment;
            }
            this._setSubscriptionsToLS(this.arSubscriptionList);
            this._commonService.arSubscriptions.next(this.arSubscriptionList);
        } else {
            this._commonService.arSubscriptions.next({});
        }
    };

    /**
   * This method will return the AR Saved Time value in Milliseconds.
   * **/

    private getArSavedTime() {
        const dateInMs =  Date.now();
        return dateInMs + 900000 ;
    }

    public fetchArSubscriptions(): void {
        const custid = this._userInfoService.getUUID();
        const builtHeaders = {...this.httpOptions};
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiSubKeyHeader, this.snsApiSubKey);
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiContentTypeHeader, 'application/vnd.safeway.v1+json');
        builtHeaders.headers = builtHeaders.headers.set('x-swy-correlation-id', this._userInfoService.getUUID());
        builtHeaders.headers = builtHeaders.headers.set('Authorization', `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-banner', this._userInfoService.getBanner());
        builtHeaders.headers = builtHeaders.headers.set('x-swy-client-name', 'safeway');

        if (custid && this.isArEnable) {
            const apiUrl = `${this.snsApiBasepath}${this.snsApi}${this._userInfoService.getUUID()}/allsubscriptions?banner=${this._userInfoService.getBanner()}`;
            this._http
                .get<any[]>(apiUrl, builtHeaders)
                .subscribe(data => {
                    this.setArSubscription(data);
                }, (err: any) => {
                    this.setArSubscription(null);
                });
        }
    }

    public _setSubscriptionsToLS (obj) {
        if (this._utilService.isLSCompatible()) {
            const subsKey = 'abNgSubscriptions';
            localStorage.setItem ( subsKey, JSON.stringify ( obj ) );
        }
    }

    // Method that will check whether to get AR subscriptions from the Subscriptions API or use it from local storage if it exists
    public getSubscriptionsInfo() {
        if(this._commonService._hasLSArSubscriptions()) {
            const subsKey = 'abNgSubscriptions';
            const obj = localStorage.getItem(subsKey);
            this._commonService.arSubscriptions.next(JSON.parse(obj));
        } else {
            this.fetchArSubscriptions();
        }
    }

    public buildAndPostAddSubscription(modalPayload): Observable<any> {
        let payload = {};
        let apiUrl = '';
        const builtHeaders = {...this.httpOptions};
        builtHeaders.headers = builtHeaders.headers.set('x-swy-banner', this._userInfoService.getBanner());
        builtHeaders.headers = builtHeaders.headers.set('Accept', 'application/vnd.safeway.v1+json');
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiContentTypeHeader, 'application/json');
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiSubKeyHeader, this.snsApiSubKey);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-client-name', 'WEB-PORTAL');
        builtHeaders.headers = builtHeaders.headers.set('subscriptionSource', modalPayload.subscriptionSource.toLowerCase() == 'pdp'? 'pdp': 'productcard');
        builtHeaders.headers = builtHeaders.headers.set('Authorization', `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-correlation-id', this._userInfoService.getUUID());
        builtHeaders.headers = builtHeaders.headers.set('x-swy-date', new Date().toUTCString());

        payload = {
            "isNewSnSUser": false,
            "originationStoreId": this._userInfoService.getShopStoreId(),
            "subscriptionItems": [
                {
                    "productBpn": modalPayload.bpn,
                    "productUpc": modalPayload.upc,
                    "quantity": Number(modalPayload.quantity),
                    "startDateTime": modalPayload.startDate,
                    "isSubstitutable":true,
                    productDesc: modalPayload?.productTitle,
                    originalPrice: modalPayload?.originalPrice?.toString(),
                    "frequency": {
                        "count": Number(modalPayload.frequency),
                        "unit": "WEEK"
                    }
                }
            ]
        };
        apiUrl =  `${this.snsApiBasepath}${this.snsApi}${this._userInfoService.getUUID()}/addsubscription`;
        return this._http.post<any[]>(apiUrl, payload, builtHeaders);
    }

    public getStaticFrequencyList() {
        return 	[
            {
                "unit": "WEEK",
                "count": 1,
                "isDefault": true,
                "displayFrequency": "week"
            }
        ];
    }
}
